<template>
  <div class="b-header shadow-sm bg-white">
    <div class="container-fluid container-xxl">
      <div class="row align-items-center">
        <div class="col">
          <el-menu
            class="b-header__menu"
            mode="horizontal"
            :default-active="topRoute"
          >
            <el-menu-item
              v-for="link in leftLinks"
              :key="link.route"
              :index="link.route"
              @click="menuClick"
            >
              {{ link.title }}
            </el-menu-item>
          </el-menu>
        </div>
        <div class="col-auto">
          <Link href="/">
            <img
              class="b-header__logo"
              src="@assets/logo.svg"
              alt=""
            >
          </Link>
        </div>
        <div class="col">
          <div class="float-end">
            <el-menu
              class="b-header__menu"
              mode="horizontal"
              :default-active="topRoute"
            >
              <el-menu-item
                v-for="link in rightLinks"
                :key="link.route"
                :index="link.route"
                @click="menuClick"
              >
                {{ link.title }}
              </el-menu-item>
              <el-menu-item>
                <i
                  v-if="!userImage"
                  class="el-icon-user-solid"
                />
                <el-image
                  v-else
                  :src="userImage"
                  fit="cover"
                  class="b-header__avatar me-2"
                />
                {{ userFio }}
              </el-menu-item>
              <el-menu-item>
                <a @click="logout()">Выйти из системы</a>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Link} from '@inertiajs/inertia-vue3';
  import UiErrors from '@/components/Ui/UiErrors';

  export default {
    name: 'Header',
    components: {
      Link,
      UiErrors,
    },
    props: {
      errors: {type: Object, default: () => null},
    },
    data() {
      return {
        open: false,
        links: [
          {title: 'Портфолио', route: 'portfolio'},
          {title: 'Услуги', route: 'portfolio'},
        ],
      };
    },
    computed: {
      isAdmin() {
        return this.$page.props.user.is_admin;
      },
      leftLinks() {
        return this.$page.props.left_links;
      },
      rightLinks() {
        return this.$page.props.right_links.filter(link => {
          return !link.is_admin || this.isAdmin;
        });
      },
      topRoute() {
        return `${this.route().current().split('.')[0]}.index`;
      },
      userId() {
        return this.$page.props.user?.b24_id;
      },
      userFio() {
        const fio = this.$page.props.user?.name || '';
        let arr = fio.split(' ');
        arr = arr.map((item, index) => (item));
        return arr.join(' ');
      },
      userImage() {
        return this.$page.props.user?.profile_photo_path || '';
      },
    },
    methods: {
      logout() {
        this.$inertia.post(this.route('logout'));
      },
      menuClick(item) {
        this.$inertia.visit(this.route(item.index), {
          onError: (errors) => {
            this.$notify.error({
              title: 'Ошибка',
              message: errors.NoAdminError,
            });
          },
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  .b-header {

    &__menu {
      border-bottom: none;
    }

    &__logo {
      height: 32px;
    }

    &__avatar {
      border-radius: 50%;
      width: 24px;
      height: 24px;
    }
  }
</style>
